import(/* webpackMode: "eager", webpackExports: ["GamesCatalog"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/games/GamesCatalog.tsx");
